import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {
  PartnerAccountListResponse,
  partnerAccountListResponseFactory,
  PartnerAccountModel,
  SinglePartnerAccountResponse,
  singlePartnerAccountResponseFactory,
} from "./partner-account.model";

const DEFAULT_PAGE = "1";
const DEFAULT_PAGE_LIMIT = "10";

@Injectable()
export class ManagePartnersService {
  private uri = "/api/partners";

  constructor(private http: HttpClient) {}

  getPartners(page = DEFAULT_PAGE, limit = DEFAULT_PAGE_LIMIT, search?: string): Promise<PartnerAccountListResponse> {
    const params = {page, limit, search, sequence: "true"};

    return this.http.get(`${this.uri}/`, {params})
      .pipe(map(partnerAccountListResponseFactory))
      .toPromise();
  }

  getPartnerById(id: string = ""): Promise<SinglePartnerAccountResponse> {
    const params = {id};

    return this.http.get(`${this.uri}/by-id`, {params})
      .pipe(map(singlePartnerAccountResponseFactory))
      .toPromise();
  }

  savePartner(partner?: PartnerAccountModel): Promise<boolean> {
    return this.http.post(`${this.uri}/save`, partner)
      .pipe(map(json => json["success"]))
      .toPromise();
  }

  sendWelcomeEmail(partnerId: string): Promise<any> {
    return this.http.post(`${this.uri}/sendWelcomeNotification`, {partnerId})
      .pipe(map(json => json["success"]))
      .toPromise();
  }
}
